/* Moon Preloader JS — supports minimum display time */
(function () {
  var preloader = document.getElementById('moon-preloader');
  if (!preloader) return;

  // Minimum time (ms) the preloader is guaranteed to show
  // Set via data-min-time attribute on the preloader element
  var minTime = parseInt(preloader.dataset.minTime || '2000', 10);
  var startTime = Date.now();
  var pageLoaded = false;

  function tryHide() {
    var elapsed = Date.now() - startTime;
    var remaining = minTime - elapsed;

    if (remaining > 0) {
      setTimeout(hidePreloader, remaining);
    } else {
      hidePreloader();
    }
  }

  function hidePreloader() {
    preloader.classList.add('moon-preloader--hidden');
    setTimeout(function () {
      if (preloader && preloader.parentNode) {
        preloader.parentNode.removeChild(preloader);
      }
    }, 750);
  }

  if (document.readyState === 'complete') {
    tryHide();
  } else {
    window.addEventListener('load', tryHide);
    // Absolute safety fallback: hide after minTime + 5000ms
    setTimeout(hidePreloader, minTime + 5000);
  }
})();
